import React from 'react';
import styled from 'styled-components';
import { useQuiz } from '../../context/QuizContext';

const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.primary};
  padding: ${({ theme }) => theme.spacing.md};
  height: 56px;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: ${({ theme }) => theme.shadows.medium};
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const LogoImage = styled.img`
  height: 24px;
  margin-right: ${({ theme }) => theme.spacing.sm};
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md};
`;

const QuizInfo = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 0.9rem;
`;

const TimeInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 0.9rem;
  margin-left: ${({ theme }) => theme.spacing.lg};
`;

const IconWrapper = styled.span`
  margin-right: ${({ theme }) => theme.spacing.sm};
  font-size: 1.2rem;
`;

const Header: React.FC = () => {
  const { quiz, quizState } = useQuiz();
  
  // Format elapsed time as HH:MM:SS
  const formatElapsedTime = (timeInSeconds: number): string => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;
    
    return [
      hours.toString().padStart(2, '0'),
      minutes.toString().padStart(2, '0'),
      seconds.toString().padStart(2, '0'),
    ].join(':');
  };
  
  // Calculate elapsed time
  const elapsedTime = React.useMemo(() => {
    if (quizState.isAnswered) {
      return quizState.timeSpent;
    }
    
    const currentTime = Math.floor((Date.now() - quizState.timeStarted) / 1000);
    return currentTime;
  }, [quizState.isAnswered, quizState.timeSpent, quizState.timeStarted]);
  
  return (
    <HeaderContainer>
      <Logo>
        <LogoImage src="/logo.svg" alt="Archer Review" />
        ARCHER REVIEW
      </Logo>
      
      <RightSection>
        {quiz && (
          <QuizInfo>
            QID: {quiz.metadata.id}
          </QuizInfo>
        )}
        
        <TimeInfo>
          <IconWrapper>⏰</IconWrapper>
          Time Elapsed : {formatElapsedTime(elapsedTime)}
        </TimeInfo>
      </RightSection>
    </HeaderContainer>
  );
};

export default Header; 